// <!------------------------------------------- Preloader JavaScript ---------------------->
 
// document.addEventListener("DOMContentLoaded", function() {
  //   if (!sessionStorage.getItem("preloaderShown")) {
  //     document.getElementById('preloader').style.display = 'flex';
  //     setTimeout(function() {
  //       document.getElementById('preloader-logo').style.opacity = '1';  
  //     }, 500); 
  //     setTimeout(function() {
  //       document.getElementById('preloader').style.opacity = '0';  
  //     }, 2400); 
  //     setTimeout(function() {
  //       document.getElementById('preloader').style.display = 'none';
  //     }, 5400); 
  //     sessionStorage.setItem("preloaderShown", "true");
  //   } else {
  //     document.getElementById('preloader').style.display = 'none';
  //   }
  // });
  // window.onbeforeunload = function() {
  //   document.getElementById('preloader').style.display = 'none';
  // };
  
  // ----------------------------------------------------------------new custom code----------
//   document.addEventListener("DOMContentLoaded", function() {
//   const preloader = document.getElementById("preloader");
//   const logo = document.getElementById("preloader-logo");
//   if (!sessionStorage.getItem("preloaderShown")) {
//     logo.style.opacity = "1";
//     setTimeout(function() {
//       preloader.style.opacity = "0";
//     }, 1200);
//     setTimeout(function() {
//       preloader.style.display = "none";
//     }, 1700);
//     sessionStorage.setItem("preloaderShown", "true");
//   } else {
//     preloader.style.display = "none";
//   }
// });

// ----------------------------------------------new 3rd code-------------------------------------

// window.addEventListener("load", function () {
//   const preloader = document.getElementById("preloader");

//   if (!preloader) return;
//   setTimeout(function () {
//     preloader.style.opacity = "0";

//     setTimeout(function () {
//       preloader.style.display = "none";
//     }, 500); 
//   }, 300);
// });

document.addEventListener("DOMContentLoaded", function () {
    const preloader = document.getElementById("preloader");

    if (!preloader) return;

    preloader.style.opacity = "0";

    setTimeout(() => {
        preloader.remove();
    }, 00);
});


// ----------------------------------------product page products slider-------------------------
document.querySelectorAll('.cus-prd-coll-tbs-bv--section').forEach((section) => {
  section.flickityInstances = {};
  section.querySelectorAll('.cus-prd-coll-tbs-bv--pane .js-flickity').forEach(slider => {
    const pane = slider.closest('.cus-prd-coll-tbs-bv--pane');
    const wasHidden = pane.style.display === 'none' || getComputedStyle(pane).display === 'none';
    if (wasHidden) pane.style.display = 'block';

    section.flickityInstances[pane.id] = new Flickity(
      slider,
      JSON.parse(slider.dataset.flickity)
    );
    if (wasHidden) pane.style.display = '';
  });

  section.querySelectorAll('.cus-prd-coll-tbs-bv--tab').forEach((tab) => {
    tab.addEventListener('click', function () {
      section.querySelectorAll('.cus-prd-coll-tbs-bv--tab').forEach(t => t.classList.remove('active'));
      section.querySelectorAll('.cus-prd-coll-tbs-bv--pane').forEach(p => p.classList.remove('active'));
      this.classList.add('active');
      const activePane = section.querySelector('#' + this.dataset.tab);
      activePane.classList.add('active');
      if (section.flickityInstances[activePane.id]) {
        section.flickityInstances[activePane.id].resize();
      }
    });
  });
});

// ---------------------------------------------icon phone header---------------------------------

document.addEventListener("DOMContentLoaded", () => {
  const drawer = document.querySelector(".cus_phn_em_cnt__drawer");
  const overlay = document.querySelector(".cus_phn_em_cnt__overlay");
  document.querySelectorAll(".cus_cnt_em_us_icn").forEach(btn => {
    btn.addEventListener("click", () => {
      drawer?.classList.add("active");
      overlay?.classList.add("active");
    });
  });

  const closeDrawer = () => {
    drawer?.classList.remove("active");
    overlay?.classList.remove("active");
  };

  document.querySelector(".cus_phn_em_cnt__close")?.addEventListener("click", closeDrawer);
  overlay?.addEventListener("click", closeDrawer);

  document.querySelectorAll("[data-acc]").forEach(item => {
    item.addEventListener("click", () => {
      const parent = item.closest(".cus_phn_em_cnt__item");
      const icon = item.querySelector(".cus_phn_em_cnt__icon");

      document.querySelectorAll(".cus_phn_em_cnt__item").forEach(acc => {
        if (acc !== parent) {
          acc.classList.remove("active");
          acc.querySelector(".cus_phn_em_cnt__icon").textContent = "+";
        }
      });

      parent.classList.toggle("active");
      icon.textContent = parent.classList.contains("active") ? "−" : "+";
    });
  });

});


// ------------------------------------------------header js sticky custom---------------------------------------------

document.addEventListener('DOMContentLoaded', function () {
  const mobileToggle = document.querySelector('.cus_mb_left_burger_wrp_3 .mobile-toggle-wrapper');
  const stickyHeader = document.querySelector('.header-section .header-sticky--active');
  if (mobileToggle && stickyHeader) {
    const observer = new MutationObserver(function () {
      if (mobileToggle.classList.contains('active')) {
        stickyHeader.classList.add('is-sticky');
      } else {
        stickyHeader.classList.remove('is-sticky');
      }
    });
    observer.observe(mobileToggle, {
      attributes: true,
      attributeFilter: ['class']
    });
  }
});


// {% comment %} --------------------------------------customizer product custom block------------------------------------ {% endcomment %}

document.addEventListener('DOMContentLoaded', function(){
  const wrapper = document.querySelector('.cus_drw_cst_prd_blk_wrapper');
  if(!wrapper) return;
  const drawer = wrapper.querySelector('.cus_drw_cst_prd_blk_drawer');
  const overlay = wrapper.querySelector('.cus_drw_cst_prd_blk_overlay');
  const messageField = wrapper.querySelector('.cus_drw_cst_prd_blk_message_field');
  let selectedFont = '';
  /* drawer open */
  wrapper.querySelector('.cus_drw_cst_prd_blk_btn').addEventListener('click', function(){
    drawer.classList.add('active');
    overlay.classList.add('active');
  });
  /* drawer close */
  function closeDrawer(){
    drawer.classList.remove('active');
    overlay.classList.remove('active');
  }
  wrapper.querySelector('.cus_drw_cst_prd_blk_close').addEventListener('click', closeDrawer);
  overlay.addEventListener('click', closeDrawer);

  /* font select */
    const fontButtons = wrapper.querySelectorAll('.cus_drw_cst_prd_blk_font_btn');
		if(fontButtons.length){
		fontButtons[0].classList.add('active');
		selectedFont = fontButtons[0].dataset.value;
		}
		fontButtons.forEach(btn => {
		btn.addEventListener('click', function(){

			fontButtons.forEach(item => {
			item.classList.remove('active');
			});
			this.classList.add('active');
			selectedFont = this.dataset.value;
		});
		});
  /* symbol click → directly add into input (max 7) */
  wrapper.querySelectorAll('.cus_drw_cst_prd_blk_symbol_btn').forEach(btn => {

    btn.addEventListener('click', function(){

      let symbol = this.dataset.value;
      let currentValue = messageField.value;

      if(currentValue.length < 7){
        messageField.value = currentValue + symbol;
      }
    });
  });
  /* manual input max 7 */
  messageField.addEventListener('input', function(){

    if(this.value.length > 7){
      this.value = this.value.slice(0, 7);
    }

  });
  /* confirm */
  wrapper.querySelector('.cus_drw_cst_prd_blk_confirm').addEventListener('click', function(){
  const messageValue = messageField.value;
  wrapper.querySelector('.cus_drw_cst_prd_blk_font_input').value = selectedFont;
  wrapper.querySelector('.cus_drw_cst_prd_blk_symbol_input').value = messageValue;
  // {% comment %} wrapper.querySelector('.cus_drw_cst_prd_blk_message_input').value = messageValue; {% endcomment %}
  closeDrawer();
	});

	const termsCheck = wrapper.querySelector('.cus_drw_cst_prd_blk_terms_check');
	const confirmBtn = wrapper.querySelector('.cus_drw_cst_prd_blk_confirm');
	termsCheck.addEventListener('change', function(){
	confirmBtn.disabled = !this.checked;
	});

});



// {% comment %} ---------------------------------------------------------size chart product page------------ {% endcomment %}

//   document.addEventListener('DOMContentLoaded', function(){
//   const wrapper = document.querySelector('.cus_sz_chrt_jsb__wrapper');
//   if(!wrapper) return;
//   const btn = wrapper.querySelector('.cus_sz_chrt_jsb__btn');
//   const popup = wrapper.querySelector('.cus_sz_chrt_jsb__popup');
//   const overlay = wrapper.querySelector('.cus_sz_chrt_jsb__overlay');
//   const close = wrapper.querySelector('.cus_sz_chrt_jsb__close');
//   btn.addEventListener('click', function(){
//     popup.classList.add('active');
//     overlay.classList.add('active');
//   });
//   function closePopup(){
//     popup.classList.remove('active');
//     overlay.classList.remove('active');
//   }
//   close.addEventListener('click', closePopup);
//   overlay.addEventListener('click', closePopup);

// });

document.addEventListener('DOMContentLoaded', function () {
  const wrapper = document.querySelector('.cus_sz_chrt_jsb__wrapper');
  if (!wrapper) return;
  const btn = wrapper.querySelector('.cus_sz_chrt_jsb__btn');
  const popup = wrapper.querySelector('.cus_sz_chrt_jsb__popup');
  const overlay = wrapper.querySelector('.cus_sz_chrt_jsb__overlay');
  const close = wrapper.querySelector('.cus_sz_chrt_jsb__close');
  const ringFinder = wrapper.querySelector('.cus_sz_chrt_tbl__open');

  // open popup
  btn.addEventListener('click', function () {
    popup.classList.add('active');
    overlay.classList.add('active');
  });

  // close popup function
  function closePopup() {
    popup.classList.remove('active');
    overlay.classList.remove('active');
  }

  close.addEventListener('click', closePopup);
  overlay.addEventListener('click', closePopup);

  // ⭐ RING FINDER (PUT HERE)
  if (ringFinder) {
    ringFinder.addEventListener('click', function (e) {
      e.preventDefault();

      // close size chart popup
      closePopup();

      // open ring finder popup (scoped)
      setTimeout(() => {
        const wrapper = ringFinder.closest('.cus_sz_chrt_jsb__wrapper');
        const ringFinderPopup = wrapper.querySelector('.ring-finder-popup');

        if (ringFinderPopup) {
          ringFinderPopup.classList.add('active');
        }
      }, 200);
    });
  }

});

// ---------------------------------------------cus heaer menu newsletter drawer form------------------

document.addEventListener('DOMContentLoaded', function(){
    const trigger = document.querySelector('.cus_new_ltr_men_item');
    const drawer = document.querySelector('.cus_nwl_jsb_frm__drawer');
    const overlay = document.querySelector('.cus_nwl_jsb_frm__overlay');
    const closeBtn = document.querySelector('.cus_nwl_jsb_frm__close');

    function closeDrawer(){
      drawer.classList.remove('active');
      overlay.classList.remove('active');
    }

    trigger.addEventListener('click', function(){
      drawer.classList.add('active');
      overlay.classList.add('active');
    });

    closeBtn.addEventListener('click', closeDrawer);
    overlay.addEventListener('click', closeDrawer);
  });

  // ----------------------------------------------------custom-request-price---------------------

document.addEventListener("DOMContentLoaded", function () {
  const openBtn = document.querySelector(".cus_prd_req_pric_wrp");
  const popup = document.querySelector(".cus_request_price_overlay");
  const closeBtn = document.querySelector(".cus_request_price_close");
  // OPEN
  if (openBtn) {
    openBtn.addEventListener("click", function () {
      popup.classList.add("active");
      document.body.style.overflow = "hidden";
    });
  }
  // CLOSE button
  if (closeBtn) {
    closeBtn.addEventListener("click", function () {
      popup.classList.remove("active");
      document.body.style.overflow = "";
    });
  }
  // CLICK OUTSIDE CLOSE
  popup.addEventListener("click", function (e) {
    if (e.target === popup) {
      popup.classList.remove("active");
      document.body.style.overflow = "";
    }
  });
});

// ---------------------------------------------------custom product media gallery------------------------------

	document.addEventListener("DOMContentLoaded", function () {
      if (!window.matchMedia("(min-width: 1068px)").matches) return;
      const slider = document.querySelector(".custm_two_column_slder_list_container #Product-Slider");
      const prevBtn = document.querySelector(".custm_two_column_slder_list_container .slider-button--prev");
      const nextBtn = document.querySelector(".custm_two_column_slder_list_container .slider-button--next");
      const currentEl = document.querySelector(".custm_two_column_slder_list_container .slider-counter--current");
      const totalEl = document.querySelector(".custm_two_column_slder_list_container .slider-counter--total");

      if (!slider) return;

      const slides = slider.querySelectorAll(".custm_two_column_slder_list_container .product-images__slide");
      const totalSlides = slides.length;

      let slideWidth = slides[0].offsetWidth;
      let currentIndex = 0;

      if (totalEl) totalEl.textContent = totalSlides;

      function updateSlider() {
        slideWidth = slides[0].offsetWidth;

        slider.scrollTo({
        left: currentIndex * slideWidth,
        behavior: "smooth"
        });

        if (currentEl) currentEl.textContent = currentIndex + 1;

        if (prevBtn) prevBtn.disabled = currentIndex === 0;
        if (nextBtn) nextBtn.disabled = currentIndex >= totalSlides - 2;
      }

      prevBtn?.addEventListener("click", () => {
        if (currentIndex > 0) {
        currentIndex--;
        updateSlider();
        }
      });

      nextBtn?.addEventListener("click", () => {
        if (currentIndex < totalSlides - 2) {
        currentIndex++;
        updateSlider();
        }
      });

      let isDragging = false;
      let startX;
      let startScroll;

      slider.addEventListener("mousedown", (e) => {
        isDragging = true;
        slider.style.cursor = "grabbing";
        startX = e.pageX;
        startScroll = slider.scrollLeft;
      });

      document.addEventListener("mouseup", () => {
        if (!isDragging) return;

        isDragging = false;
        slider.style.cursor = "grab";

        currentIndex = Math.round(slider.scrollLeft / slideWidth);
        updateSlider();
      });

      slider.addEventListener("mousemove", (e) => {
        if (!isDragging) return;

        e.preventDefault();

        const walk = e.pageX - startX;
        slider.scrollLeft = startScroll - walk;
      });

      slider.addEventListener("touchend", () => {
        currentIndex = Math.round(slider.scrollLeft / slideWidth);
        updateSlider();
      });

      window.addEventListener("resize", updateSlider);

      updateSlider();

	});

  // -------------------------------------------------------------------product page add to cart show hide with variant price-----------------

//   document.addEventListener("change", () => {
//     setTimeout(() => {
//     const selected = document.querySelector('[id^="SelectedVariant"]');
//     const btn = document.querySelector('.cus_crt_add_btn_wrp');
//     if (!selected || !btn) return;
//     const variantId = selected.dataset.variantId;
//     const activeInput = document.querySelector('input:checked');
//     if (!activeInput) return;
//     const price = activeInput.getAttribute('cus-data-price');
//     btn.style.display = (price == "0" || price == 0) ? "none" : "block";
//    }, 100);
// });


// ---------------------------------------------------------------------------custom js size chart size guide------------------------------

document.addEventListener('DOMContentLoaded', function () {
    const popup = document.getElementById('cus_sz_chrt_tbl__popup');
    const closeBtn = document.getElementById('cus_sz_chrt_tbl__close');

    // Open popup from any button (even dynamically loaded)
    document.addEventListener('click', function(e) {
        if (e.target.closest('.cus_sz_chrt_tbl__open')) {
            popup.classList.add('active');
            document.body.style.overflow = 'hidden';
        }
    });

    function closePopup() {
        popup.classList.remove('active');
        document.body.style.overflow = '';
    }

    if(closeBtn){
        closeBtn.addEventListener('click', closePopup);
    }

    if(popup){
        popup.addEventListener('click', function(e) {
            if (e.target === popup) {
                closePopup();
            }
        });
    }
});


// --------------------------------------------foooter bottom --------------------
document.addEventListener("DOMContentLoaded", function () {
  const items = document.querySelectorAll(".cus_jstbrl_ftr_btm_item");
  items.forEach(item => {
    const title = item.querySelector(".has-submenu");
    if(title){
      title.addEventListener("click", function(){
        const isActive = item.classList.contains("active");
        items.forEach(i => i.classList.remove("active"));
        if(isActive) return;

        item.classList.add("active");
        setTimeout(() => {
          item.scrollIntoView({
            behavior: "smooth",
            block: "start"
          });
        }, 200);
      });
    }
  });
});